<template>
  <div>
    <div v-if="options.showTitle">
      <span class="cs-title">会员信息</span>
    </div>
    <!-- <el-row class="hidden-xs-only">
      <el-col>
        <label> &nbsp; </label>
      </el-col>
    </el-row> -->
    <div v-if="!showError && !!model.studentId">
      <el-row v-if="options.showPhone">
        <el-col :span="6">
          <span>手机号码：</span>
        </el-col>
        <el-col :span="18">
          <span>{{model.phone}}</span>
          <el-button class="edit-button" v-if="options.enableResetPassword" type="text" size="medium" @click="onResetPas">重置密码</el-button>
          <el-button class="edit-button margin-left-20px" v-if="options.enableResetPassword" type="text" size="medium" @click="onResetWechat">微信解绑</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>姓：</span>
        </el-col>
        <el-col :span="18">
          <div v-if="!editLastNameModel.editable">
            <span>{{model.lastName}}</span>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onEditLastName">编辑</el-button>
          </div>
           <div v-else>
            <el-input size="mini" v-model="editLastNameModel.editValue"></el-input>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onSaveLastName">保存</el-button>
            <el-button class="edit-button" type="text" size="medium" @click="onCancelLastName">取消</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>名：</span>
        </el-col>
        <el-col :span="18">
          <div v-if="!editFirstNameModel.editable">
            <span>{{model.firstName}}</span>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onEditFirstName">编辑</el-button>
          </div>
           <div v-else>
            <el-input size="mini" v-model="editFirstNameModel.editValue"></el-input>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onSaveFirstName">保存</el-button>
            <el-button class="edit-button" type="text" size="medium" @click="onCancelFirstName">取消</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>会员邮箱：</span>
        </el-col>
        <el-col :span="18">
          <div v-if="!editEmailModel.editable">
            <span>{{model.email}}</span>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onEditEmail">编辑</el-button>
          </div>
          <div v-else>
            <el-input size="mini" v-model="editEmailModel.editValue"></el-input>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onSaveEmail">保存</el-button>
            <el-button class="edit-button" type="text" size="medium" @click="onCancelEmail">取消</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>积分：</span>
        </el-col>
        <el-col :span="18">
          <div v-if="!editBonusPointModel.editable">
            <span>{{model.bonusPoint}}</span>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onEditBonusPoint">编辑</el-button>
          </div>
          <div v-else>
            <el-input-number size="mini" v-model="editBonusPointModel.editValue" :min="0" :max="99999"></el-input-number>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onSaveBonusPoint">保存</el-button>
            <el-button class="edit-button" type="text" size="medium" @click="onCancelBonusPoint">取消</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="options.enableEdit || USERMANAGER.isFrontDesk">
        <el-col :span="6">
          <span>赠送余额：</span>
        </el-col>
        <el-col :span="18">
         <span>${{model.giftBalance|toFixedString}}</span>
        </el-col>
      </el-row>
      <el-row v-if="options.enableEdit || USERMANAGER.isFrontDesk">
        <el-col :span="6">
          <span>旧余额：</span>
        </el-col>
        <el-col :span="18">
          <div v-if="!editBalanceModel.editable">
            <span>${{model.balance|toFixedString}}</span>
            <!-- <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onEditBalance">编辑</el-button> -->
          </div>
          <div v-else>
            <el-input-number size="mini" v-model="editBalanceModel.editValue" :min="0" :precision="2" :max="99999"></el-input-number>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onSaveBalance">保存</el-button>
            <el-button class="edit-button" type="text" size="medium" @click="onCancelBalance">取消</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="options.enableEdit || USERMANAGER.isFrontDesk">
        <el-col :span="6">
          <span>新余额：</span>
        </el-col>
        <el-col :span="18">
          <div v-if="!editNewBalanceModel.editable">
            <span>${{model.newBalance|toFixedString}}</span>
            <!-- <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onEditNewBalance">编辑</el-button> -->
          </div>
          <div v-else>
            <el-input-number size="mini" v-model="editNewBalanceModel.editValue" :min="0" :precision="2" :max="99999"></el-input-number>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onSaveNewBalance">保存</el-button>
            <el-button class="edit-button" type="text" size="medium" @click="onCancelNewBalance">取消</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row class="cs-memberInfo-balanceTotal">
        <el-col :span="6">
          <span>可使用剩余余额：</span>
        </el-col>
        <el-col :span="18">
          <div class="cs-memberInfo-balanceTotal-content">
            <span>${{model.balanceTotal|toFixedString}}</span>
            <span class="cs-memberInfo-balanceTotal-note">(其中包含[剩余学费] + [赠送学费 | 不可转让或退现])</span>
          </div>
        </el-col>
      </el-row>
      <el-row class="cs-memberInfo-giftBalanceTotal">
        <el-col :span="6">
          <span>历史累计赠送学费：</span>
        </el-col>
        <el-col :span="18">
          <div class="cs-memberInfo-giftBalanceTotal-content">
            <span>${{model.giftBalanceTotal|toFixedString}}</span>
            <span class="cs-memberInfo-giftBalanceTotal-note">(指历史上曾获得过的赠送学费总额，仅用于展示，不代表当前可用余额)</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>历史赠送学费总额：</span>
        </el-col>
        <el-col :span="18">
          <div>
            <span>${{model.giftBalanceTotal|toFixedString}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>可使用剩余余额：</span>
        </el-col>
        <el-col :span="18">
          <div>
            <span>${{model.balanceTotal|toFixedString}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>欠款：</span>
        </el-col>
        <el-col :span="18">
          <div v-if="!editBalanceModel.editable">
            <span>{{model.balanceDue|toCurrency}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>可用占位名额：</span>
        </el-col>
        <el-col :span="18">
          <div v-if="!editAeCountModel.editable">
            <span>{{studentAdvanceEnrollmentList.length - studentAdvanceUsed }}<br> </span>
            <span v-for="ae in studentAdvanceEnrollmentList" v-if="!ae.Used" :key="ae.Key">定金: {{ae.Amount}} $ | 折扣: {{ae.Discount}} % {{ae.Comment}} ({{ae.CreateTime.substring(0,10) }})<br> </span>
            <span>(已使用{{studentAdvanceUsed}})</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>可用职业培训占位名额：</span>
        </el-col>
        <el-col :span="18">
          <div v-if="!editTrainingAeCountModel.editable">
            <span>{{model.trainingAeCount}}</span>
            <span v-if="(model.trainingAeCount > 0 || model.trainingAeCountUsed > 0) && !!model.trainingAdvanceEnrollmentDateText">({{model.trainingAdvanceEnrollmentDateText}})</span>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onEditTrainingAeCount">编辑</el-button>
          </div>
          <div v-else>
            <el-input-number size="mini" v-model="editTrainingAeCountModel.editValue" :min="0" :precision="2" :max="99999"></el-input-number>
            <el-button class="edit-button" v-if="options.enableEdit" type="text" size="medium" @click="onSaveTrainingAeCount">保存</el-button>
            <el-button class="edit-button" type="text" size="medium" @click="onCancelTrainingAeCount">取消</el-button>
          </div>
          <span>(已使用{{model.trainingAeCountUsed}})</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>会员类型：</span>
        </el-col>
        <el-col :span="18">
          <span v-if="hasBuyMemberCard" class="cs-color-frenchgrey">非会员(购买中)</span>
          <span v-else-if="!model.isMember" class="cs-color-frenchgrey">非会员</span>
          <span v-else>普通会员</span>
          <span v-if="!!options.enableBuymember && !model.isMember">
            <el-button v-if="!hasBuyMemberCard" class="edit-button" size="medium" type="text" @click="showBuyMemberEditor">购买会员</el-button>
            <el-button v-else class="edit-button cs-redLabel" size="medium" type="text" @click="cancelBuyMemberCard">撤销</el-button>
          </span>
          <span v-if="model.isMember" style="margin-left: 10px;">
            <a :href="model.memberCardVersion === 1 ?  memberCardConfig.ContractFileV1 : memberCardConfig.ContractFile" target="_blank">黑卡会员须知</a>
          </span>
        </el-col>
      </el-row>
      <el-row v-if="model.isMember">
        <el-col :span="6">
          <span>会员卡号：</span>
        </el-col>
        <el-col :span="18">
          <span>{{model.memberCardNumber}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span>会员卡有效期：</span>
        </el-col>
        <el-col :span="18">
          <span v-if="!!model.memberCardExpiryDate">{{model.memberCardStartDate}} - {{model.memberCardExpiryDate}}</span>
          <span v-else>从未办理</span>
        </el-col>
      </el-row>
      <el-row v-if="options.showIsNew && !model.isAuId">
        <el-col>
          <span class="cs-color-green">该账号信息显示此学生为新生</span>
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <el-row>
        <el-col>
          <span class="cs-color-frenchgrey" v-text="errorMessage"></span>
          <el-button v-if="!!options.enableRegister" class="edit-button" size="medium" type="text" @click="showStudentRegisterEditor">注册账号</el-button>
        </el-col>
      </el-row>
    </div>
    <el-dialog :close-on-click-modal="false" title="注册账号" :center="true" width="600px" :visible.sync="studentRegisterVisible" top="8vh">
      <studentregister-editor ref="studentregister-editor" :data-in="studentRegisterModel" @closeDialog="onStudentRegisterEditorClose" @saveSuccess="onStudentRegisterEditorSaveSuccess"></studentregister-editor>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" width="600px" :visible.sync="buyMemberEditorVisible" top="8vh">
      <buymembercard-editor ref="buymembercard-editor" :data-in="buyMemberModel" @closeDialog="onBuyMemberEditorClose" @saveSuccess="onBuyMemberEditorSaveSuccess"></buymembercard-editor>
    </el-dialog>
    <el-dialog title="重置密码" :center="true" :close-on-click-modal="false" :visible.sync="resetPasswordDialogVisibe" top="10vh">
      <passwordEditor type="resetPassword" :studentId="model.studentId" v-on:closeEditor="onCloseEditor"></passwordEditor>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.edit-button {
  padding: 0px;
  margin-left: 10px;
}

.contract-items {
  .contract-item {
    display: block;

    .el-link {
      margin-right: 5px;
    }
  }
}
.cs-memberInfo-balanceTotal{
  font-size: 18px;
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 5px;

  .cs-memberInfo-balanceTotal-content{
    span{
      display: block;
      line-height: 18px;
    }
    .cs-memberInfo-balanceTotal-note{
      font-size: 14px;
    }
  }
}
.cs-memberInfo-giftBalanceTotal{
  font-size: 14px;
  color: grey;
  margin-bottom: 15px;

  .cs-memberInfo-giftBalanceTotal-content{
    span{
      display: block;
      line-height: 18px;
    }
    .cs-memberInfo-giftBalanceTotal-note{

    }
  }
}
</style>

<script>
import { downloadFile } from "@/config/mUtils";
import { getMemberCardConfig } from "@/service/common.service";
import {
  createStudentMemberInfoModel,
  getStudentMemberInfo,
  saveStudentBonusPoint,
  saveStudentBalance,
  saveStudentNewBalance,
  saveStudentFirstName,
  saveStudentLastName,
  saveStudentEmail,
  saveStudentAdvanceEnrollmentCount,
  saveTrainingAdvanceEnrollmentCount
  } from "../../service/student.service.js";
import {removeWechat} from "../../service/user.service.js";
import { getAllStudentAdvanceEnrollmentByStudentId}  from "../../service/advanceEnrollment.service.js";
import {
  getBlobFileUrlById,
  downloadFileToBlob,
} from "@/service/blobStorage.service";

import studentregisterEditor from "./studentRegisterEditor";
import buymembercardEditor from "./buyMemberCardEditor";
import passwordEditor from "../passwordEditor";

let moment = require("moment");
export default {
  props: {
    dataIn: {
      memberModel: Object,
      hasBuyMemberCard:Boolean
    },
    options:{
      showTitle: Boolean,
      showPhone:Boolean,
      enableEdit: Boolean,
      enableBuymember : Boolean,
      showIsNew: Boolean,
      enableRegister: Boolean,
      enableResetPassword: Boolean
    }
  },
  data() {
    return {
      resetPasswordDialogVisibe: false,
      showError: false,
      errorMessage: "未查询到该学生",
      memberCardConfig: {
        ContractFile: null
      },
      editFirstNameModel: {
        editable: false,
        editValue: ""
      },
      editLastNameModel: {
        editable: false,
        editValue: ""
      },
      editEmailModel: {
        editable: false,
        editValue: ""
      },
      editBonusPointModel: {
        editable: false,
        editValue: 0
      },
      editBalanceModel: {
        editable: false,
        editValue: 0
      },
      editNewBalanceModel: {
        editable: false,
        editValue: 0
      },
      editAeCountModel: {
        editable: false,
        editValue: 0
      },
      editTrainingAeCountModel:{
        editable: false,
        editValue: 0
      },
      studentRegisterVisible: false,
      studentRegisterModel: {
        phone:""
      },
      buyMemberModel: {
        phone:""
      },
      buyMemberEditorVisible: false,
      hasBuyMemberCard : false,
      model: {
          studentId : 0,
          phone : "" ,
          firstName: "",
          lastName: "",
          name : "",
          email :"",
          bonusPoint : 0,
          balance : 0,
          newBalance: 0,
          giftBalance: 0,
          giftBalanceTotal: 0,
          balanceTotal: 0,
          balanceDue : 0,
          aeCount : 0,
          aeCountUsed : 0,
          isMember: false,
          isAuId : false,
          memberCardNumber: "",
          memberCardExpiryDate: "",
          memberCardVersion: 0,
          advanceEnrollmentDateText : "",
          trainingAeCount : 0,
          trainingAeCountUsed : 0,
          trainingAdvanceEnrollmentDateText : "",
      },
      studentAdvanceEnrollmentList:[],
      studentAdvanceUsed:0
    };
  },
  components: {
    studentregisterEditor,
    buymembercardEditor,
    passwordEditor
  },
  created() {
    this.loadMemberCardConfigFromServer();
    this.loadData();
  },
  computed: {
    aeItems() {
      let entityList = [];
      this.studentAdvanceEnrollmentList.forEach(saeItem => {
        if (saeItem.CourseType !== this.GLOBAL.courseType.university)
          return;

        let entity = entityList.find(entity => entity.ContractId === saeItem.ContractId);
        if (!entity) {
          entity = {
            ContractId: saeItem.ContractId,
            ContractName: saeItem.ContractName,
            SelectedAdvanceEnrollments: [],
            ContractFiles: []
          };
          entityList.push(entity);
        }
        
        if (!!saeItem.SelectedAdvanceEnrollmentId && entity.SelectedAdvanceEnrollments.every(sae => sae.Id != saeItem.SelectedAdvanceEnrollmentId)) {
          entity.SelectedAdvanceEnrollments.push({
            Id: saeItem.SelectedAdvanceEnrollmentId,
            Name: saeItem.SelectedAdvanceEnrollmentComment
          });
        }

        saeItem.ContractFiles.forEach(cFile => {
          if (entity.ContractFiles.some(entity => entity.ContractId === cFile.ContractId))
            return;

          entity.ContractFiles.push(cFile);
        });
      });
      return entityList;
    },
    taeItems() {
      let entityList = [];
      this.studentAdvanceEnrollmentList.forEach(saeItem => {
        if (saeItem.CourseType !== this.GLOBAL.courseType.vocationalTraining)
          return;

        let entity = entityList.find(entity => entity.ContractId === saeItem.ContractId);
        if (!entity) {
          entity = {
            ContractId: saeItem.ContractId,
            ContractName: saeItem.ContractName,
            SelectedAdvanceEnrollments: [],
            ContractFiles: []
          };
          entityList.push(entity);
        }
        
        if (!!saeItem.SelectedAdvanceEnrollmentId && entity.SelectedAdvanceEnrollments.every(sae => sae.Id != saeItem.SelectedAdvanceEnrollmentId)) {
          entity.SelectedAdvanceEnrollments.push({
            Id: saeItem.SelectedAdvanceEnrollmentId,
            Name: saeItem.SelectedAdvanceEnrollmentComment
          });
        }

        if (saeItem.ContractFiles){
          saeItem.ContractFiles.forEach(cFile => {
            if (entity.ContractFiles.some(entity => entity.ContractId === cFile.ContractId))
              return;

            entity.ContractFiles.push(cFile);
          });
        }
      });
      return entityList;
    }
  },
  methods: {
    async loadMemberCardConfigFromServer() {
      try {
        let result = await getMemberCardConfig();
        if (!!result && result.success) {
          this.memberCardConfig = result.data;
        }
      } catch (error) {
      }
    },

    loadData() {   
      if (!!this.dataIn && !!this.dataIn.memberModel) {
        
        this.loadMemberModel(this.dataIn.memberModel);
        this.hasBuyMemberCard = this.dataIn.hasBuyMemberCard;
      } else {
        this.loadMemberModel();
        this.hasBuyMemberCard = false;
      }
    },
    loadMemberModel(memberModel) {
      if (!memberModel || !memberModel.StudentId){
          this.showError = true;
          this.model.studentId = 0;
          this.model.phone = !memberModel ? "" : memberModel.phone;
          this.model.firstName = "";
          this.model.lastName = "";
          this.model.name = "";
          this.model.email ="";
          this.model.bonusPoint = 0;
          this.model.balance = 0;
          this.model.newBalance = 0;
          this.model.giftBalance = 0;
          this.model.giftBalanceTotal = 0;
          this.model.balanceTotal = 0;
          this.model.balanceDue = 0;
          this.model.aeCount = 0;
          this.model.aeCountUsed = 0;
          this.model.isMember = false;
          this.model.isAuId = false;
          this.model.memberCardNumber = "";
          this.model.memberCardExpiryDate = "";
          this.model.memberCardVersion = 0;
          this.model.advanceEnrollmentDateText = "";
          this.model.trainingAeCount = 0;
          this.model.trainingAeCountUsed = 0;
          this.model.trainingAdvanceEnrollmentDateText = "";
      }else{
        this.showError = false;
        this.model.studentId = memberModel.StudentId;
        this.model.phone = memberModel.Phone;
        this.model.firstName = memberModel.FirstName;
        this.model.lastName = memberModel.LastName;
        this.model.name = memberModel.Name;
        this.model.email = memberModel.Email;
        this.model.bonusPoint = memberModel.BonusPoint;
        this.model.balance = memberModel.Balance;
        this.model.newBalance = memberModel.NewBalance;
        this.model.giftBalance = memberModel.GiftBalance;
        this.model.giftBalanceTotal = memberModel.GiftBalanceTotal;
        this.model.balanceTotal = memberModel.BalanceTotal;
        this.model.balanceDue = memberModel.BalanceDue;
        this.model.aeCount = memberModel.AdvanceEnrollmentCount - memberModel.AdvanceEnrollmentCountUsed;
        this.model.aeCountUsed = memberModel.AdvanceEnrollmentCountUsed;
        this.model.isMember = memberModel.IsMember;
        this.model.isAuId = memberModel.IsAuId;
        this.model.memberCardNumber = memberModel.MemberCardNumber;
        this.model.memberCardStartDate = memberModel.MemberCardStartDateText;
        this.model.memberCardExpiryDate = memberModel.MemberCardExpiryDateText;
        this.model.memberCardVersion = memberModel.MemberCardVersion;
        this.model.advanceEnrollmentDateText = memberModel.AdvanceEnrollmentDateText;
        this.model.trainingAeCount = memberModel.TrainingAdvanceEnrollmentCount - memberModel.TrainingAdvanceEnrollmentCountUsed;
        this.model.trainingAeCountUsed = memberModel.TrainingAdvanceEnrollmentCountUsed;
        this.model.trainingAdvanceEnrollmentDateText = memberModel.TrainingAdvanceEnrollmentDateText;
      }
    },
    async loadStudentMemberInfo(studentId) {
      this.errorMessage = "";
      this.showError = false;

      let result = await getStudentMemberInfo(studentId).then(result => {
        if (result && result.success) {
          this.loadMemberModel(result.data);
        } else {
          this.loadMemberModel();
        }
      });
    },
    onResetPas(){
      this.resetPasswordDialogVisibe = true;
    },
    onCloseEditor(){
       this.resetPasswordDialogVisibe = false;
    },
    onResetWechat(){
      this.$confirm(
        "您确定要将解绑该学生的微信吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          removeWechat(
            this.model.studentId
          ).then(result => {
            if (!!result && result.success) {
              this.$message({
                message: "修改成功",
                type: "success"
              });
            } else {
              this.$message.error("修改失败" + result.message);
            }
          });
        })
        .catch(() => {});
    },
    onEditBonusPoint() {
      this.editBonusPointModel.editable = true;
      this.editBonusPointModel.editValue = this.model.bonusPoint;
    },
    onSaveBonusPoint() {
      this.$confirm(
        "您确定要将该学生的积分修改为:" +
          this.editBonusPointModel.editValue +
          "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveStudentBonusPoint(
            this.model.studentId,
            this.editBonusPointModel.editValue
          ).then(result => {
            if (!!result && result.success) {
              this.$message({
                message: "积分修改成功",
                type: "success"
              });
              this.model.bonusPoint = this.editBonusPointModel.editValue;
              this.onCancelBonusPoint();
            } else {
              this.$message.error("保存失败" + result.message);
            }
          });
        })
        .catch(() => {});
    },
    onCancelBonusPoint() {
      this.editBonusPointModel.editable = false;
    },
    onEditBalance() {
      this.editBalanceModel.editable = true;
      this.editBalanceModel.editValue = this.model.balance;
    },
    onSaveBalance() {
      this.$confirm(
        "您确定要将该学生的旧余额修改为:" + this.editBalanceModel.editValue + "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveStudentBalance(
            this.model.studentId,
            this.editBalanceModel.editValue
          ).then(result => {
            if (!!result && result.success) {
              this.$message({
                message: "旧余额修改成功",
                type: "success"
              });
              this.model.balance = this.editBalanceModel.editValue;
              this.onCancelBalance();
              this.calculateBalanceTotal();
            } else {
              this.$message.error("保存失败" + result.message);
            }
          });
        })
        .catch(() => {});
    },
    onCancelBalance() {
      this.editBalanceModel.editable = false;
    },
    onEditNewBalance() {
      this.editNewBalanceModel.editable = true;
      this.editNewBalanceModel.editValue = this.model.newBalance;
    },
    onSaveNewBalance() {
      this.$confirm(
        "您确定要将该学生的新余额修改为:" + this.editNewBalanceModel.editValue + "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveStudentNewBalance(
            this.model.studentId,
            this.editNewBalanceModel.editValue
          ).then(result => {
            if (!!result && result.success) {
              this.$message({
                message: "新余额修改成功",
                type: "success"
              });
              this.model.newBalance = this.editNewBalanceModel.editValue;
              this.onCancelNewBalance();
              this.calculateBalanceTotal();
            } else {
              this.$message.error("保存失败" + result.message);
            }
          });
        })
        .catch(() => {});
    },
    onCancelNewBalance() {
      this.editNewBalanceModel.editable = false;
    },
    onEditAeCount() {
      this.editAeCountModel.editable = true;
      this.editAeCountModel.editValue = this.model.aeCount;
    },
    onSaveAeCount() {
      this.$confirm(
        "您确定要将该学生的可用占位修改为:" + this.editAeCountModel.editValue + "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          let count = this.editAeCountModel.editValue + this.model.aeCountUsed;
          saveStudentAdvanceEnrollmentCount(
            this.model.studentId,
            count
          ).then(result => {
            if (!!result && result.success) {
              this.$message({
                message: "可用占位修改成功",
                type: "success"
              });
              this.model.aeCount = this.editAeCountModel.editValue;
              this.onCancelAeCount();
            } else {
              this.$message.error("保存失败" + result.message);
            }
          });
        })
        .catch(() => {});
    },
    onCancelAeCount() {
      this.editAeCountModel.editable = false;
    },
    onEditTrainingAeCount() {
      this.editTrainingAeCountModel.editable = true;
      this.editTrainingAeCountModel.editValue = this.model.trainingAeCount;
    },
    onSaveTrainingAeCount() {
      this.$confirm(
        "您确定要将该学生的可用职业培训占位修改为:" + this.editTrainingAeCountModel.editValue + "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          let count = this.editTrainingAeCountModel.editValue + this.model.trainingAeCountUsed;
          saveTrainingAdvanceEnrollmentCount(
            this.model.studentId,
            count
          ).then(result => {
            if (!!result && result.success) {
              this.$message({
                message: "可用职业培训占位修改成功",
                type: "success"
              });
              this.model.trainingAeCount = this.editTrainingAeCountModel.editValue;
              this.onCancelTrainingAeCount();
            } else {
              this.$message.error("保存失败" + result.message);
            }
          });
        })
        .catch(() => {});
    },
    onCancelTrainingAeCount() {
      this.editTrainingAeCountModel.editable = false;
    },
    onEditFirstName() {
      this.editFirstNameModel.editable = true;
      this.editFirstNameModel.editValue = this.model.firstName;
    },
    onSaveFirstName() {
      if (!this.editFirstNameModel.editValue) {
        this.$message.error("请输入驾照，护照，学生证上合法的Legal Name");
        return;
      }

      this.$confirm(
        "您确定要将该学生的名修改为:" + this.editFirstNameModel.editValue + "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveStudentFirstName(
            this.model.studentId,
            this.editFirstNameModel.editValue
          ).then(result => {
            if (!!result && result.success) {
              this.$message({
                message: "名修改成功",
                type: "success"
              });
              this.model.firstName = this.editFirstNameModel.editValue;
              this.onCancelFirstName();
            } else {
              this.$message.error("保存失败" + result.message);
            }
          });
        })
        .catch(() => {});
    },
    onCancelFirstName() {
      this.editFirstNameModel.editable = false;
    },
    onEditLastName() {
      this.editLastNameModel.editable = true;
      this.editLastNameModel.editValue = this.model.lastName;
    },
    onSaveLastName() {
      if (!this.editLastNameModel.editValue) {
        this.$message.error("请输入驾照，护照，学生证上合法的Legal Name");
        return;
      }

      this.$confirm(
        "您确定要将该学生的姓修改为:" + this.editLastNameModel.editValue + "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveStudentLastName(
            this.model.studentId,
            this.editLastNameModel.editValue
          ).then(result => {
            if (!!result && result.success) {
              this.$message({
                message: "姓修改成功",
                type: "success"
              });
              this.model.lastName = this.editLastNameModel.editValue;
              this.onCancelLastName();
            } else {
              this.$message.error("保存失败" + result.message);
            }
          });
        })
        .catch(() => {});
    },
    onCancelLastName() {
      this.editLastNameModel.editable = false;
    },
    onEditEmail() {
      this.editEmailModel.editable = true;
      this.editEmailModel.editValue = this.model.email;
    },
    onSaveEmail() {
      let mailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/; //正则表达式
      if (!mailReg.test(this.editEmailModel.editValue)) {
        this.$message.error("邮箱格式不正确");
        return;
      }

      this.$confirm(
        "您确定要将该学生的邮箱修改为:" + this.editEmailModel.editValue + "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          saveStudentEmail(
            this.model.studentId,
            this.editEmailModel.editValue
          ).then(result => {
            if (!!result && result.success) {
              this.$message({
                message: "邮箱修改成功",
                type: "success"
              });
              this.model.email = this.editEmailModel.editValue;
              this.onCancelEmail();
            } else {
              this.$message.error("保存失败" + result.message);
            }
          });
        })
        .catch(() => {});
    },
    onCancelEmail() {
      this.editEmailModel.editable = false;
    },
    showStudentRegisterEditor() {
      this.studentRegisterModel = {phone:this.model.phone};

      this.studentRegisterVisible = true;
    },
    onStudentRegisterEditorClose() {
      this.studentRegisterVisible = false;
    },
    onStudentRegisterEditorSaveSuccess(result) {
      //this.loadStudentMemberInfo(null, result.user.Name);
      this.$emit("register", {phone: this.model.phone});
    },
    showBuyMemberEditor() {
      let editModel = {phone:this.model.phone};
      this.buyMemberModel = editModel;

      this.buyMemberEditorVisible = true;
    },
    cancelBuyMemberCard() {
      this.$confirm("您确定要撤销购买会员?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.hasBuyMemberCard = false;
        this.model.memberCardNumber = null;
        this.$emit("buyMemberCard", {phone: this.model.phone, isBuy: false});
      }).catch(() => {});
    },
    onBuyMemberEditorClose() {
      this.buyMemberEditorVisible = false;
    },
    onBuyMemberEditorSaveSuccess(result) {
      this.hasBuyMemberCard = true;
      this.model.memberCardNumber = result.memberCardNumber;
      this.$emit("buyMemberCard", {phone: this.model.phone, isBuy: true});
    },
    setHasBuyMemberCard(value){
      this.hasBuyMemberCard = value;
    },
    async loadStudentAdvanceEnrollments() {
      await getAllStudentAdvanceEnrollmentByStudentId(this.model.studentId).then(result => {
        if (!!result && result.success) {
          this.studentAdvanceEnrollmentList = result.data;
          this.studentAdvanceUsed = 0;
          this.studentAdvanceEnrollmentList.forEach(element => {
            if (element.Used) {
              this.studentAdvanceUsed += 1;
            }
          });
        }
      });
    },
    downloadContractFile(file) {
      this.$set(file, "_downloadLoading", true);
      getBlobFileUrlById(file.FileStorageId)
        .then((result) => {
          if (!!result && result.success) {
            let { Url, FileName } = result.data;
            downloadFileToBlob(Url, 0)
              .then((res) => {
                if (!!res && res.success && !!res.data)
                  downloadFile({ data: res.data, filename: FileName });
                else this.$message.error("未能正确获取到文件数据。");

                this.$set(file, "_downloadLoading", false);
              })
              .catch(() => {
                this.$set(file, "_downloadLoading", false);
              });
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }
          }

          this.$set(file, "_downloadLoading", false);
        })
        .catch(() => {
          this.$set(file, "_downloadLoading", false);
        });
    },
    calculateBalanceTotal(){
      return this.model.balance + this.model.newBalance + this.model.giftBalance;
    }
  },
  watch: {
    "dataIn.hasBuyMemberCard":function(value){
      this.hasBuyMemberCard = value;
    },
    dataIn: function() {
      this.loadData();
      this.loadStudentAdvanceEnrollments();
    }  
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/memberInfo_new.vue